/* eslint-disable better-mutation/no-mutation */

function BubbledFocus() {
    //Focus event is not bubbled with event delegation
    //However, event capturing works, so we use that to listen to focus events instead
    //see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html

    const boundNodes = [];

    this.focus = function (selector, fn) {
        const callFn = function (evt) {
            this._raise(evt, selector, fn);
        }.bind(this);

        this._captureEvent('focus', callFn);
        //IE does not do event capturing, but we can use it's focusin event istead
        this.on('focusin', callFn);
    };

    this.blur = function (selector, fn) {
        const callFn = function (evt) {
            this._raise(evt, selector, fn);
        }.bind(this);

        this._captureEvent('blur', callFn);
        //IE does not do event capturing, but we can use it's focusout event istead
        this.on('focusout', fn);
    };

    this._captureEvent = function (event, fn) {
        this.$node.each(function () {
            if (this.addEventListener) {
                this.addEventListener(event, fn, true);
                boundNodes.push({ element: this, fn: fn, event: event });
            }
        });
    };

    this._raise = function (evt, selector, fn) {
        const allowedTargets = this.$node.find(selector);
        const length = allowedTargets.length;
        for (let i = 0; i < length; i++) {
            if (allowedTargets[i] === evt.target) {
                fn(evt);
            }
        }
    };

    this.detachFocus = function () {
        let data, i, length;
        for (i = 0, length = boundNodes.length; i < length; i++) {
            data = boundNodes[i];
            if (data.element.removeEventListener) {
                data.element.removeEventListener(data.event, data.fn, true);
            }
        }
        boundNodes.length = 0;
    };

    this.after('initialize', function () {
        this.on(document, 'ui:teardown', this.detachFocus);
    });
}

export default BubbledFocus;
